import { memo, useCallback, useMemo } from 'react';

import clsx from 'clsx';

import { Button } from '../button/Button';
import { useStyles } from './BulletNav.styles';
import { BulletNavProps } from './BulletNav.types';

export const BulletNav = memo(
  ({ currentStep, totalSteps, setCurrentStep, onPrev, onNext, onClose }: BulletNavProps) => {
    const styles = useStyles();

    const isFirst = useMemo(() => currentStep === 0, [currentStep]);

    const isLast = useMemo(() => currentStep + 1 === totalSteps, [currentStep, totalSteps]);

    const showNavigationButtons = useMemo(() => !!setCurrentStep, [setCurrentStep]);

    const handlePrev = useCallback(() => {
      if (!isFirst) {
        setCurrentStep?.(currentStep - 1);
      }

      if (onPrev) {
        onPrev();
      }
    }, [currentStep, isFirst, onPrev, setCurrentStep]);

    const handleNext = useCallback(() => {
      if (!isLast) {
        setCurrentStep?.(currentStep + 1);
      } else if (onClose) {
        onClose();
      }

      if (onNext) {
        onNext();
      }
    }, [currentStep, isLast, onClose, onNext, setCurrentStep]);

    return (
      <div className={styles.bulletNav}>
        {showNavigationButtons && (
          <Button color="primary" fullWidth disabled={isFirst} className={styles.bulletButton} onClick={handlePrev}>
            Back
          </Button>
        )}

        <div className={styles.list}>
          {Array.from(Array(totalSteps).keys()).map((_, index) => (
            <div key={index} className={clsx(styles.bullet, index === currentStep && 'active')} />
          ))}
        </div>

        {showNavigationButtons && (
          <Button
            color="primary"
            fullWidth
            disabled={isLast && !onClose}
            className={styles.bulletButton}
            onClick={handleNext}
          >
            {isLast && onClose ? 'Close' : 'Next'}
          </Button>
        )}
      </div>
    );
  },
);
